import { render, staticRenderFns } from "./RemoveLdpDialog.vue?vue&type=template&id=8712c24a&scoped=true"
import script from "@/components/curriculum/RemoveLdpDialog/RemoveLdpDialog.ts?vue&type=script&lang=ts&external"
export * from "@/components/curriculum/RemoveLdpDialog/RemoveLdpDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./RemoveLdpDialog.vue?vue&type=style&index=0&id=8712c24a&prod&lang=scss&scoped=true"
import style1 from "./RemoveLdpDialog.vue?vue&type=style&index=1&id=8712c24a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8712c24a",
  null
  
)

export default component.exports